import React, {useEffect, useRef, useState} from "react";
import flatpickr from 'flatpickr';
import { formatDate, formatDateTime, getTotalDays, startLoader, stopLoader } from '../../../lib/utils';
import { getBranch } from "../../gyms/helper/api";
import { isAuthenticated } from "../../../auth";
import { getTaxes } from "../../../core/helper/TaxApiCall";
import { freezeMembership } from "../helper/api";
import Toast from "../../../lib/toast";


const FreezeMembershipModal = (props) => {

  const membership = props.membership;
  const [isButtonLock,setButtonLock] = useState(false);
  const freezeStartDateRef = useRef(null);
  const freezeEndDateRef = useRef(null);
  const [billingInfo, setBillingInfo] = useState({
    baseAmount:0,
    taxableAmount:0,
    subTotal: 0,
    surCharges: 0,
    taxBreakup: [],   // CGST, SGST, etc
    totalTax: 0,
    payableAmount: 0,
    remainingAmount: 0
  });
  const [taxType,setTaxType] = useState('');
  const [taxes, setTaxes] = useState([]); // server taxes
  const [currentElementId, setCurrentElementId] = useState("");
  const [freezeStartDate, setFreezeStartDate] = useState("");
  const [freezeEndDate, setFreezeEndDate] = useState("");
  const [freezeCharges, setFreezeCharges] = useState("");
  const [Surcharges, setSurcharges] = useState("");
  const [remark, setRemark] = useState("");
  const [freezeConfig,setFreezeConfig] = useState({
    frequency:1,
    min_duration:0,
    max_duration:0,
    min_membership_plan_duration:0,
    policy:''
  });
  const {user,token} = isAuthenticated();
  const [branchInfo,setBranchInfo] = useState('');
  const [paymentSources, setPaymentSources] = useState({
    online: ["NEFT", "RTGS", "IMPS", "UPI", "Credit Card", "Debit Card", "Juice"],
    wallet: ["Paytm", "PhonePe", "Google Pay", "Amazon Pay"]
  });
  const cardTypes = ["Visa", "Mastercard", "Zeta", "Rupay", "Amex", "Bajaj Finserv", "Tata Card"];
  const isMobile = window.innerWidth < 768;
  const startPickerRef = useRef(null);
  const endPickerRef = useRef(null);

  const closePickers = () => {
    if (startPickerRef.current && startPickerRef.current.isOpen) startPickerRef.current.close();
    if (endPickerRef.current && endPickerRef.current.isOpen) endPickerRef.current.close();
  };
  const [invoiceDetails, setInvoiceDetails] = useState({
    paymentMode: "online",
    paymentSource: "",
    chequeNumber: "",
    bankName: "",
    upiId: "",
    comment: "",
    transactionID: "",
    cardType: "",
    approvedCode: "",
    paymentNumber: ""
  });

   const FreezeMembership = async event =>{
    startLoader()
    setButtonLock(true)
    try{
      let payload = {
        ...billingInfo,
        starts_at:freezeStartDate,
        ends_at:freezeEndDate,
        amountPaid:billingInfo.payableAmount,
        ...invoiceDetails,
        remark,
        action:'freeze',
        message: `Freezed ${membership?.user?.[0]?.name} By ${user.name} on ${formatDate(new Date())}`,
        actionTakenByUserId: user._id,
        actionTakenByUserRole: user.role,
      }

      if(membership?.isPackage == true && membership?.groupPackageId){
        payload.packageId = membership.groupPackageId
      }

      let response = await freezeMembership(user._id,token,membership._id,payload);
      if(response.error){
        new Toast({
          type:'error',
          duration:3000,
          message:response.error
        })
      }else{
         new Toast({
          type:'success',
          duration:3000,
          message:'Membership freezed successfully'
        })
        props.reload();
        props.toggleFitnessTestModal("freeze-membership");
      }
    }catch(error){
      
    }
    setButtonLock(false)
    stopLoader();
   }


   const handlePaymentMode = paymentMode => event =>{
    try{
      setInvoiceDetails(oldstate=>{

        oldstate.paymentMode = paymentMode;
        oldstate.paymentSource = "";
        oldstate.chequeNumber = "";
        oldstate.bankName = "";
        oldstate.upiId = "";
        oldstate.comment = "";
        oldstate.transactionID = "";

        return {
          ...oldstate
        }
      })
    }catch(error){
      
    }
  }

  const handleSelectPaymentSource = (source) => {
    setInvoiceDetails((oldState) => ({
      ...oldState,
      paymentSource: source
    }))
  }

  const handleSelectCard = (getCardType) => {
    setInvoiceDetails((oldState) => ({
      ...oldState,
      cardType: getCardType
    }))
  }

     const GetAllTaxes = async () =>{
        try{
          const branchId = localStorage.getItem("branchId");
          const params = {
            branchId,
            noLimit:'noLimit'
          };
          const responses = await getTaxes(user._id,token,params);
    
          if(!responses.error){
            setTaxes(responses);
          }
        }catch(error){
    
        }
      }
  
    const applyInclusive = () =>{
      if(taxType == "inclusive-tax") setTaxType("")
      else setTaxType("inclusive-tax")
    }
  
  
    const applyTaxes = event =>{
      if(taxType == "additional-tax") setTaxType("")
      else setTaxType('additional-tax');
    }

  const GetBranch = async () =>{
    try{
      let branchId = localStorage.getItem("branchId")
      if(!branchId) return;

      let response = await getBranch(user._id,token,branchId);
      if(!response.error){
        setBranchInfo(response);
      }
    }catch(error){

    }
  }

  const toggleInputFields = (elementId) => event => {
    if (currentElementId == elementId) {
      setCurrentElementId('')
      closePickers();
    }else{
      setCurrentElementId(elementId);

      if(elementId == "freeze-start-date"){
        openFreezeStartDate();
      }

      if(elementId == "freeze-end-date"){
        openFreezeEndDate();
      }

      if (event) {
        let interval = setInterval(() => {
          let element = event.target.querySelector('input');
          if (element) {
            element.focus();
            clearInterval(interval)
          }
        }, 0);
      }
    }

  }

  const handleChange = (name,value) => event => {
    if(name == "freeze-charges"){
      setFreezeCharges(event.target.value)
    }else  if(name == "surcharges"){
      setSurcharges(event.target.value)
    }else if(name == "remark"){
      setRemark(event.target.value)
    }else {
      value = !value ? event.target.value : value; 
      setInvoiceDetails({
        ...invoiceDetails,
        [name]: value
      });
    }
  }

  const openFreezeStartDate = () => {
     if (startPickerRef.current) {
    startPickerRef.current.destroy();
    startPickerRef.current = null;
  }

  startPickerRef.current = flatpickr("#freeze-start-date", {
      
      disableMobile: true,
      onClose: () => setCurrentElementId(''),
      onChange: ([date]) => {
        try{
        let endDate;
        if(freezeEndDate){
          endDate= new Date(freezeEndDate);
          endDate.setHours(23,59,59,59);
        }
        if(endDate && new Date(date)>endDate){
          new Toast({
            type:'warning',
            duration:3000,
            message:'Start date can not be greater then end date'
          })
          return;
        }



        if(endDate){
          let startDate = new Date(date)
          startDate.setHours(0,0,0,0);
          if(getTotalDays(new Date(startDate),new Date(endDate))>freezeConfig.max_duration){
            new Toast({
              type:'warning',
              duration:3000,
              message:`freeze duration should not be more then ${freezeConfig.max_duration} day's`
            })
            return;
          }


          if(getTotalDays(new Date(startDate),new Date(endDate))<freezeConfig.min_duration){
            new Toast({
              type:'warning',
              duration:3000,
              message:`freeze duration should not be less then ${freezeConfig.min_duration} day's`
            })
            return;
          }
        }


        // const istDate = date.toLocaleDateString('en-CA', {
        //   timeZone: 'Asia/Kolkata'
        // });



        setFreezeStartDate(date)
      }catch(error){
        alert(error)
      }
      }
    });
   startPickerRef.current.open();
  }

  const openFreezeEndDate = () => {
      if (endPickerRef.current) {
    endPickerRef.current.destroy();
    endPickerRef.current = null;
  }

  endPickerRef.current = flatpickr("#freeze-end-date", {

    
      disableMobile: true,
      position: "auto right",
      onOpen: (selectedDates, dateStr, instance) => {
        if (isMobile) {
          const cal = instance.calendarContainer;
          cal.style.position = "fixed";
          
        }
      },
      onClose: () => setCurrentElementId(''),
      onChange: ([date]) => {
        let startDate;
        if(freezeStartDate){
          startDate = new Date(freezeStartDate);
          startDate.setHours(0,0,0,0);
        }
        if(startDate && new Date(date)<startDate){
          new Toast({
            type:'warning',
            duration:3000,
            message:'End date can not be lesser then start date'
          })
          return;
        }
        // const istDate = date.toLocaleDateString('en-CA', {
        //   timeZone: 'Asia/Kolkata'
        // });
        
        if(startDate){
          let endDate = new Date(date);
          endDate.setHours(23,59,59,59)
          if(getTotalDays(new Date(startDate),new Date(endDate))>freezeConfig.max_duration){
            new Toast({
              type:'warning',
              duration:3000,
              message:`freeze duration should not be more then ${freezeConfig.max_duration} day's`
            })
            return;
          }


          if(getTotalDays(new Date(startDate),new Date(endDate))<freezeConfig.min_duration){
            new Toast({
              type:'warning',
              duration:3000,
              message:`freeze duration should not be less then ${freezeConfig.min_duration} day's`
            })
            return;
          }
        }
        setFreezeEndDate(date)
      }
    });
     endPickerRef.current.open();
  }

  useEffect(async ()=>{
    try{
      await startLoader();
      GetAllTaxes();
    }catch(error){
      console.log(error)
    };
    
    try{
      await startLoader()
      await GetBranch();
    }catch(error){

    }
    await stopLoader();
  },[]);

  useEffect(()=>{
    if(!branchInfo) return;
    let newFreezeConfig = branchInfo?.branchconfig?.[0]?.freezeConfig || {};
    setFreezeConfig({
      ...freezeConfig,
      ...newFreezeConfig
    })
  },[branchInfo])

  useEffect(() => {
    if (!membership) return;

    const surchargePercent = Number(Surcharges ||
      0);

    // 1️⃣ Base Subtotal
    let baseAmount = Number(freezeCharges || 0);

    // 2️⃣ Surcharge
    const surCharges = Number((baseAmount * surchargePercent) / 100);


    let taxBreakup = [];
    let totalTax = 0;

    if (taxType && taxes.length) {
      const totalTaxPercent = taxes.reduce(
        (sum, t) => parseFloat(parseFloat(sum) + (parseFloat(t.value) || 0)),
        0
      );

      if (taxType == "inclusive-tax") {
        // ✅ Extract tax from amount
        const inclusiveTax =
          (baseAmount * totalTaxPercent) /
          (100 + totalTaxPercent);
          

        totalTax = inclusiveTax;

        taxBreakup = taxes.map(tax => {
          const amount =
            (inclusiveTax * tax.value) / totalTaxPercent;

          return {
            ...tax,
            amount: amount.toFixed(2)
          };
        });
      } else if(taxType == "additional-tax") {
        // ✅ Exclusive tax (normal add-on)
        taxBreakup = taxes.map(tax => {
          const amount =
            (baseAmount * tax.value) / 100;
          totalTax += amount;

          return {
            ...tax,
            amount: amount.toFixed(2)
          };
        });
      }
    }

    const taxableAmount = taxType == "inclusive-tax"
      ? baseAmount - totalTax
      : baseAmount;

    const subTotal = taxType != "additional-tax"
      ? baseAmount
      : baseAmount + totalTax;

    // 3️⃣ Payable
    const payableAmount =
      subTotal + surCharges;

    setBillingInfo(prev => ({
      ...prev,
      taxBreakup,
      baseAmount,
      taxableAmount: Math.round(taxableAmount),
      subTotal: Math.round(subTotal),
      surCharges: Math.round(surCharges),
      payableAmount: Math.round(payableAmount)
    }));

  }, [freezeCharges,taxType, taxes,Surcharges]);

  useEffect(()=>{
    if(freezeStartDate && freezeEndDate){
      setButtonLock(false)
    }else{
      setButtonLock(true);
    }
  },[freezeEndDate,freezeStartDate]);
  useEffect(() => {
  return () => {
    if (startPickerRef.current) startPickerRef.current.destroy();
    if (endPickerRef.current) endPickerRef.current.destroy();
  };
  }, []);
  
  if(!membership) return <></>;

  return(
    <div className={`${window.innerWidth > 767 ? "global-modal-container d-flex" : "w-full h-full"}`}>
      <div className={`${window.innerWidth > 767 ? "freeze-membership-modal flex-item" : "w-full h-full"}`}>
        {
          window.innerWidth > 767 && (
            <div className="w-full d-flex space-between" style={{background: "var(--darkBlue)", padding:"12px", borderRadius: "16px 16px 0 0"}}>
              <div className='d-flex'>
                <svg className='flex-item m-r-12' width="30" height="30" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M8.61538 1L12 4.38462M12 4.38462L15.3846 1M12 4.38462V19.6154M1 15.3846L4.38462 12M4.38462 12L1 8.61538M4.38462 12H19.6154M15.3846 23L12 19.6154M12 19.6154L8.61538 23M23 8.61538L19.6154 12M19.6154 12L23 15.3846M6.07692 6.07692L8.61538 8.61538M8.61538 15.3846L6.07692 17.9231M17.9231 6.07692L15.3846 8.61538M15.3846 15.3846L17.9231 17.9231" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                <p className="flex-item fs-18 font-weight-600 color-white m-l-5">Freeze Membership</p>
              </div>
              <div onClick={()=>props.toggleFitnessTestModal("freeze-membership")} className="d-flex desktop-modal-close-button" style={{width: "30px", height:"30px", background:"#f9f9f9"}}>
                <svg className="flex-item" width="20" height="20" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M4.9283 3.80866C4.77899 3.66445 4.57901 3.58465 4.37144 3.58646C4.16387 3.58826 3.96531 3.67152 3.81853 3.8183C3.67175 3.96508 3.58849 4.16364 3.58668 4.37121C3.58488 4.57879 3.66468 4.77876 3.80888 4.92807L8.38076 9.49995L3.80809 14.0718C3.73248 14.1449 3.67217 14.2322 3.63068 14.3288C3.58919 14.4254 3.56735 14.5293 3.56644 14.6344C3.56552 14.7395 3.58555 14.8437 3.62536 14.941C3.66516 15.0383 3.72395 15.1267 3.79828 15.2011C3.87261 15.2754 3.961 15.3342 4.0583 15.374C4.15559 15.4138 4.25983 15.4338 4.36495 15.4329C4.47007 15.432 4.57395 15.4101 4.67054 15.3687C4.76712 15.3272 4.85448 15.2669 4.92751 15.1912L9.50018 10.6194L14.0721 15.1912C14.2214 15.3354 14.4213 15.4152 14.6289 15.4134C14.8365 15.4116 15.035 15.3284 15.1818 15.1816C15.3286 15.0348 15.4119 14.8363 15.4137 14.6287C15.4155 14.4211 15.3357 14.2211 15.1915 14.0718L10.6196 9.49995L15.1915 4.92807C15.3357 4.77876 15.4155 4.57879 15.4137 4.37121C15.4119 4.16364 15.3286 3.96508 15.1818 3.8183C15.035 3.67152 14.8365 3.58826 14.6289 3.58646C14.4213 3.58465 14.2214 3.66445 14.0721 3.80866L9.50018 8.38053L4.9283 3.80786V3.80866Z" fill="black" />
                </svg>
              </div>
            </div>
          )
        }
        <div className="w-full" onTouchStart={closePickers} onClick={closePickers} style={{height:"92%", overflowY:"auto", paddingBottom:"100px"}}>
          <div className="w-full" style={{padding:"12px"}}>
            <div className="w-full" style={{border:"1px dashed #9a9a9a", borderRadius:"12px", background:"#ffffff", padding:"12px"}}>
              <div className="flex-item d-flex space-between m-b-12">
                <p className="flex-item">Minimum Freeze Duration:</p>
                <p className="flex-item font-weight-700">{freezeConfig.min_duration} Days</p>
              </div>
              <div className="flex-item d-flex space-between m-b-12">
                <p className="flex-item">Maximum Freeze Duration:</p>
                <p className="flex-item font-weight-700">{freezeConfig.max_duration} Days</p>
              </div>
              <div className="flex-item d-flex space-between m-b-12">
                <p className="flex-item">Remaining Freeze Days:</p>
                <p className="flex-item font-weight-700">{membership.used_freeze_days?`${membership.used_freeze_days} Day's`:'-'}</p>
              </div>
              <div className="flex-item d-flex space-between m-b-12">
                <p className="flex-item">Original Membership End Date:</p>
                <p className="flex-item font-weight-700">{membership.original_ends_at_string?membership.original_ends_at_string:membership.ends_at_string}</p>
              </div>
                <div className="flex-item d-flex space-between m-b-12">
                <p className="flex-item">Extended Membership End Date:</p>
                <p className="flex-item font-weight-700">{membership.original_ends_at_string?membership.ends_at_string:'NA'}</p>
              </div>
              <div className="flex-item m-t-12 m-b-12" style={{width:"100%", height:"1px", background:"#e0e0e0"}} />
              <div className="d-flex-wrap space-between">
                <div id="freeze-start-date" onClick={(e) => { e.stopPropagation(); toggleInputFields('freeze-start-date')(e); }} onTouchStart={(e) => e.stopPropagation()} className={`${currentElementId == "freeze-start-date" || freezeStartDate ? "member-global-input-field m-b-12 flex-item" : "member-global-input-field m-b-12 flex-item d-flex"}`} style={{ border: currentElementId == "freeze-start-date" || freezeStartDate ? "1px solid var(--darkBlue)" : "", width:"48%" }}>
                  <div className="flex-item d-flex">
                    <p className="placeholder-txt flex-item" style={{ fontSize: currentElementId == "freeze-start-date" || freezeStartDate ? "10px" : "14px", color: currentElementId == "freeze-start-date" || freezeStartDate ? "var(--darkBlue)" : "", transition: "180ms" }}>Freeze Start Date</p>
                  </div>
                  <input placeholder='DD-MM-YYYY' value={freezeStartDate && formatDateTime(new Date(freezeStartDate))} className={`${currentElementId == "freeze-start-date" || freezeStartDate ? "active-input-field" : "inactive-input-field"}`} type="text" />
                </div>
                <div id="freeze-end-date" onClick={(e) => { e.stopPropagation(); toggleInputFields('freeze-end-date')(e); }} onTouchStart={(e) => e.stopPropagation()} className={`${currentElementId == "freeze-end-date" || freezeEndDate ? "member-global-input-field m-b-12 flex-item" : "member-global-input-field m-b-12 flex-item d-flex"}`} style={{ border: currentElementId == "freeze-end-date" || freezeEndDate ? "1px solid var(--darkBlue)" : "", width:"48%" }}>
                  <div className="flex-item d-flex">
                    <p className="placeholder-txt flex-item" style={{ fontSize: currentElementId == "freeze-end-date" || freezeEndDate ? "10px" : "14px", color: currentElementId == "freeze-end-date" || freezeEndDate ? "var(--darkBlue)" : "", transition: "180ms" }}>Freeze End Date</p>
                  </div>
                  <input placeholder='DD-MM-YYYY' value={freezeEndDate && formatDateTime(freezeEndDate)} className={`${currentElementId == "freeze-end-date" || freezeEndDate ? "active-input-field" : "inactive-input-field"}`} type="text" />
                </div>
                <div onClick={toggleInputFields('freeze-charges')} className={`${currentElementId == "freeze-charges" || freezeCharges ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"}`} style={{ border: currentElementId == "freeze-charges" || freezeCharges ? "1px solid var(--darkBlue)" : "", width:"48%" }}>
                  <div className="flex-item d-flex">
                    <p className="placeholder-txt flex-item" style={{ fontSize: currentElementId == "freeze-charges" || freezeCharges ? "10px" : "14px", color: currentElementId == "freeze-charges" || freezeCharges ? "var(--darkBlue)" : "", transition: "180ms" }}>Freeze Charges</p>
                  </div>
                  <input onChange={handleChange("freeze-charges")} id="freeze-charges" placeholder='Enter Amount' value={freezeCharges} className={`${currentElementId == "freeze-charges" || freezeCharges ? "active-input-field" : "inactive-input-field"}`} type="number" />
                </div>
              </div>
            </div>
            {/* 
            <div className="m-b-20 m-t-20 d-flex">
              <input className="flex-item m-r-8" type="checkbox" style={{width:"20px", height:"20px"}} />
              <p className="flex-item font-weight-700 color-dark-blue fs-16">Apply Taxes</p>
            </div> */}

            <div className="m-b-20 m-t-20 d-flex">
              <div className="flex-item d-flex">
                <input onClick={applyInclusive} checked={taxType == "inclusive-tax"} className="flex-item m-r-8" type="checkbox" style={{width:"20px", height:"20px"}} />
                <p className="flex-item font-weight-700 color-dark-blue fs-16">Inclusive Taxes</p>
              </div>
              <div className="flex-item d-flex m-l-8">
                <input onClick={applyTaxes} checked={taxType == "additional-tax"} className="flex-item m-r-8" type="checkbox" style={{width:"20px", height:"20px"}} />
                <p className="flex-item font-weight-700 color-dark-blue fs-16">Additional Taxes</p>
              </div>
            </div>

            <div className="w-full d-flex-wrap">
              {/* <div className="d-flex space-between flex-item m-b-16 m-r-40" style={{width:"34%"}}>
                <p className="flex-item">CGST (5.0%)</p>
                <p className="flex-item font-weight-700">₹ 0.0</p>
              </div>
              <div className="d-flex space-between flex-item m-b-16" style={{width:"34%"}}>
                <p className="flex-item">SGST (5.0%)</p>
                <p className="flex-item font-weight-700">₹ 0.0</p>
              </div>
              <div className="d-flex space-between flex-item m-b-16" style={{width:"34%"}}>
                <p className="flex-item">Subtotal</p>
                <p className="flex-item font-weight-700">₹ 0.0</p>
              </div> */}

               {taxType && <div className="w-full d-flex-wrap">
              {
                billingInfo.taxBreakup.map(tax=>{
                  return (
                    <div className="d-flex space-between flex-item m-b-16 m-r-40" style={{width:"34%"}}>
                      <p className="flex-item">{tax.name} ( {tax.value} % )</p>
                      <p className="flex-item font-weight-700">₹ {tax.amount}</p>
                    </div>
                  )
                })
              }
              </div>}
            </div>

            <div onClick={toggleInputFields('surcharges')} className={`${currentElementId == "surcharges" || Surcharges ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} m-b-20`} style={{ border: currentElementId == "surcharges" || Surcharges ? "1px solid var(--darkBlue)" : "", width:"50%" }}>
              <div className="flex-item d-flex">
                <p className="placeholder-txt flex-item" style={{ fontSize: currentElementId == "surcharges" || Surcharges ? "10px" : "14px", color: currentElementId == "surcharges" || Surcharges ? "var(--darkBlue)" : "", transition: "180ms" }}>Surcharges (%)</p>
              </div>
              <input id="surcharges" onChange={handleChange("surcharges")} placeholder='0.0' value={Surcharges} className={`${currentElementId == "surcharges" || Surcharges ? "active-input-field" : "inactive-input-field"}`} type="text" />
            </div>
            
            <div className="d-flex space-between flex-item m-b-16" style={{width: isMobile ? "100%" : "34%"}}>
              <p className="flex-item font-weight-700 color-black" style={{whiteSpace:"nowrap"}}>Payable Amount</p>
              <p className="flex-item font-weight-700 color-red" style={{whiteSpace:"nowrap"}}>₹ {billingInfo.payableAmount}</p>
            </div>
            {/* <div className="d-flex space-between flex-item m-b-16" style={{width:"34%"}}>
              <p className="flex-item">Amount Paid</p>
              <p className="flex-item font-weight-700">₹ 0.0</p>
            </div> */}

            <p className="color-dark-blue font-weight-600 fs-14 m-t-20">Payment Mode</p>
            <div className="d-flex-wrap space-between m-t-8">
              <div onClick={handlePaymentMode("online")} className="flex-item d-flex">
                <input className="flex-item m-r-8" type="radio"  checked={invoiceDetails.paymentMode == "online"} style={{width:"20px", height:"20px"}}/>
                <p className="flex-item font-weight-600 fs-16">Online</p>
              </div>
              <div onClick={handlePaymentMode("wallet")} className="flex-item d-flex">
                <input checked={invoiceDetails.paymentMode == "wallet"} className="flex-item m-r-8" type="radio"  style={{width:"20px", height:"20px"}}/>
                <p className="flex-item font-weight-600 fs-16">Wallet</p>
              </div>
              <div onClick={handlePaymentMode("cheque")} className="flex-item d-flex">
                <input checked={invoiceDetails.paymentMode == "cheque"} className="flex-item m-r-8" type="radio" style={{width:"20px", height:"20px"}} />
                <p className="flex-item font-weight-600 fs-16">Cheque</p>
              </div>
              <div onClick={handlePaymentMode("cash")} className="flex-item d-flex">
                <input checked={invoiceDetails.paymentMode == "cash"} className="flex-item m-r-8" type="radio" style={{width:"20px", height:"20px"}}/>
                <p className="flex-item font-weight-600 fs-16">Cash</p>
              </div>
              <div onClick={handlePaymentMode("other")} className="flex-item d-flex">
                <input checked={invoiceDetails.paymentMode == "other"} className="flex-item m-r-8" type="radio" style={{width:"20px", height:"20px"}}/>
                <p className="flex-item font-weight-600 fs-16">Other</p>
              </div>
            </div>

                     <div className="m-t-16 p-t-4 p-b-4">

            {
              (invoiceDetails.paymentMode == "online" || invoiceDetails.paymentMode == "wallet") && (
                <div className="w-full">
                  <div onClick={toggleInputFields('paymentSource')} className={`${currentElementId == "paymentSource" || invoiceDetails.paymentSource ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} m-b-12`} style={{ border: (currentElementId == "paymentSource" || invoiceDetails.paymentSource) ? "1px solid var(--darkBlue)" : "", height:"auto", minHeight:"54px", width:"100%" }}>
                      {
                        isMobile ? (
                          <div className='d-flex w-full space-between'>
                            <div className='flex-item'>
                              <div className="flex-item d-flex">
                                <svg className="flex-item m-r-4" width={(currentElementId == "paymentSource" || invoiceDetails.paymentSource) ? "14" : "24"} height={(currentElementId == "paymentSource" || invoiceDetails.paymentSource) ? "14" : "24"} style={{ transition: "180ms" }} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M13.5 12.423C12.936 12.423 12.4617 12.2307 12.077 11.846C11.6924 11.4613 11.5 10.987 11.5 10.423C11.5 9.859 11.6924 9.38467 12.077 9C12.4617 8.61533 12.936 8.423 13.5 8.423C14.064 8.423 14.5384 8.61533 14.923 9C15.3077 9.38467 15.5 9.859 15.5 10.423C15.5 10.987 15.3077 11.4613 14.923 11.846C14.5384 12.2307 14.064 12.423 13.5 12.423ZM7.30802 15.616C6.86335 15.616 6.48302 15.4577 6.16702 15.141C5.85035 14.8243 5.69202 14.444 5.69202 14V6.846C5.69202 6.402 5.85035 6.022 6.16702 5.706C6.48368 5.39 6.86368 5.23167 7.30702 5.231H19.692C20.1367 5.231 20.517 5.389 20.833 5.705C21.149 6.021 21.3074 6.40133 21.308 6.846V14C21.308 14.444 21.1497 14.824 20.833 15.14C20.517 15.4573 20.137 15.616 19.693 15.616H7.30802ZM8.30802 14.616H18.692C18.692 14.168 18.8504 13.7867 19.167 13.472C19.483 13.1573 19.863 13 20.307 13V7.846C19.8603 7.846 19.4797 7.688 19.165 7.372C18.8497 7.05533 18.692 6.675 18.692 6.231H8.30802C8.30802 6.67833 8.14968 7.05933 7.83302 7.374C7.51702 7.68867 7.13702 7.846 6.69302 7.846V13C7.13968 13 7.52068 13.1583 7.83602 13.475C8.15068 13.791 8.30802 14.171 8.30802 14.615M17.846 18.615H4.30802C3.86335 18.615 3.48302 18.457 3.16702 18.141C2.85035 17.8243 2.69202 17.444 2.69202 17V8.692C2.69202 8.55067 2.74002 8.432 2.83602 8.336C2.93202 8.24 3.05102 8.192 3.19302 8.192C3.33502 8.192 3.45368 8.24 3.54902 8.336C3.64435 8.432 3.69202 8.55067 3.69202 8.692V17C3.69202 17.1533 3.75602 17.2943 3.88402 17.423C4.01268 17.5517 4.15402 17.616 4.30802 17.616H17.846C17.988 17.616 18.1067 17.6637 18.202 17.759C18.298 17.855 18.346 17.974 18.346 18.116C18.346 18.258 18.298 18.3767 18.202 18.472C18.106 18.5673 17.9874 18.6143 17.846 18.615ZM7.30802 14.616H6.69202V6.23H7.30802C7.14135 6.23 6.99702 6.291 6.87502 6.413C6.75302 6.535 6.69202 6.679 6.69202 6.845V14C6.69202 14.1667 6.75302 14.311 6.87502 14.433C6.99702 14.555 7.14135 14.616 7.30802 14.616Z" fill={(currentElementId == "paymentSource" || invoiceDetails.paymentSource) ? "var(--darkBlue)" : "#6d6d6d"}/>
                                </svg>
                                <p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == "paymentSource" || invoiceDetails.paymentSource) ? "10px" : "16px", lineHeight: (currentElementId == "paymentSource" || invoiceDetails.paymentSource) ? "10px" : "16px", color: (currentElementId == "paymentSource" || invoiceDetails.paymentSource) ? "var(--darkBlue)" : "", transition: "180ms" }}>Payment is done via</p>
                              </div>
                              <input readOnly id="paymentSource" value={invoiceDetails.paymentSource || ""} type="text" className={`${(currentElementId == "paymentSource" || invoiceDetails.paymentSource) ? "active-input-field" : "inactive-input-field"}`} placeholder="Payment is done via" style={{ marginTop: (currentElementId == "paymentSource" || invoiceDetails.paymentSource) ? "6px" : "" }} />
                            </div>
                            <div className='input-field-arrow-dropdown' style={{ margin: "12px 8px 4px 0", transition: "180ms" }}>
                              <svg className="flex-item" style={{ transform: currentElementId == "paymentSource" ? "rotate(180deg)" : "", transition: "180ms" }} width="13" height="8" viewBox="0 0 13 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M1 1L6.5 6.5L12.5 1" stroke="var(--darkBlue)" strokeLinecap="round" />
                              </svg>
                            </div>
                          </div>
                        ) : (
                          <>
                            <div className="flex-item d-flex" style={{marginTop: (currentElementId == "paymentSource" || invoiceDetails.paymentSource) ? "4px" : ""}}>
                              <svg className="flex-item m-r-4" width={(currentElementId == "paymentSource" || invoiceDetails.paymentSource) ? "14" : "24"} height={(currentElementId == "paymentSource" || invoiceDetails.paymentSource) ? "14" : "24"} style={{ transition: "180ms" }} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M13.5 12.423C12.936 12.423 12.4617 12.2307 12.077 11.846C11.6924 11.4613 11.5 10.987 11.5 10.423C11.5 9.859 11.6924 9.38467 12.077 9C12.4617 8.61533 12.936 8.423 13.5 8.423C14.064 8.423 14.5384 8.61533 14.923 9C15.3077 9.38467 15.5 9.859 15.5 10.423C15.5 10.987 15.3077 11.4613 14.923 11.846C14.5384 12.2307 14.064 12.423 13.5 12.423ZM7.30802 15.616C6.86335 15.616 6.48302 15.4577 6.16702 15.141C5.85035 14.8243 5.69202 14.444 5.69202 14V6.846C5.69202 6.402 5.85035 6.022 6.16702 5.706C6.48368 5.39 6.86368 5.23167 7.30702 5.231H19.692C20.1367 5.231 20.517 5.389 20.833 5.705C21.149 6.021 21.3074 6.40133 21.308 6.846V14C21.308 14.444 21.1497 14.824 20.833 15.14C20.517 15.4573 20.137 15.616 19.693 15.616H7.30802ZM8.30802 14.616H18.692C18.692 14.168 18.8504 13.7867 19.167 13.472C19.483 13.1573 19.863 13 20.307 13V7.846C19.8603 7.846 19.4797 7.688 19.165 7.372C18.8497 7.05533 18.692 6.675 18.692 6.231H8.30802C8.30802 6.67833 8.14968 7.05933 7.83302 7.374C7.51702 7.68867 7.13702 7.846 6.69302 7.846V13C7.13968 13 7.52068 13.1583 7.83602 13.475C8.15068 13.791 8.30802 14.171 8.30802 14.615M17.846 18.615H4.30802C3.86335 18.615 3.48302 18.457 3.16702 18.141C2.85035 17.8243 2.69202 17.444 2.69202 17V8.692C2.69202 8.55067 2.74002 8.432 2.83602 8.336C2.93202 8.24 3.05102 8.192 3.19302 8.192C3.33502 8.192 3.45368 8.24 3.54902 8.336C3.64435 8.432 3.69202 8.55067 3.69202 8.692V17C3.69202 17.1533 3.75602 17.2943 3.88402 17.423C4.01268 17.5517 4.15402 17.616 4.30802 17.616H17.846C17.988 17.616 18.1067 17.6637 18.202 17.759C18.298 17.855 18.346 17.974 18.346 18.116C18.346 18.258 18.298 18.3767 18.202 18.472C18.106 18.5673 17.9874 18.6143 17.846 18.615ZM7.30802 14.616H6.69202V6.23H7.30802C7.14135 6.23 6.99702 6.291 6.87502 6.413C6.75302 6.535 6.69202 6.679 6.69202 6.845V14C6.69202 14.1667 6.75302 14.311 6.87502 14.433C6.99702 14.555 7.14135 14.616 7.30802 14.616Z" fill={(currentElementId == "paymentSource" || invoiceDetails.paymentSource) ? "var(--darkBlue)" : "#6d6d6d"}/>
                              </svg>
                              <p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == "paymentSource" || invoiceDetails.paymentSource) ? "10px" : "16px", lineHeight: (currentElementId == "paymentSource" || invoiceDetails.paymentSource) ? "10px" : "16px", color: (currentElementId == "paymentSource" || invoiceDetails.paymentSource) ? "var(--darkBlue)" : "", transition: "180ms" }}>Payment is done via</p>
                            </div>
                            <div className='input-field-arrow-dropdown' style={{ margin: "18px 12px 4px 0", transition: "180ms" }}>
                              <svg className="flex-item" style={{ transform: currentElementId == "paymentSource" ? "rotate(180deg)" : "", transition: "180ms" }} width="13" height="8" viewBox="0 0 13 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M1 1L6.5 6.5L12.5 1" stroke="var(--darkBlue)" stroke-linecap="round" />
                              </svg>
                            </div>
                            <p id="paymentSource" className={`flex-item fs-16 m-t-24 ${(currentElementId == "paymentSource") ? "active-input-field color-grey-04" : invoiceDetails.paymentSource ? "active-input-field" : "inactive-input-field"}`}>{invoiceDetails.paymentSource ? invoiceDetails.paymentSource : "Payment is done via"}</p>
                          </>
                        )
                      }

                      {
                        currentElementId == "paymentSource" && (
                          <div className="global-input-field-arrow-dropdown global-input-field-arrow-dropdown-height-1 scaleFromTopToBottom" style={{background:"#f5f5f5", border: "1px solid #f5f5f5", marginTop : !isMobile && invoiceDetails.paymentSource ? "70px" : undefined, padding: "0"}}>
                            {
                              invoiceDetails.paymentMode == "online" && (
                                <div className="w-full" style={{padding:"0px 8px 8px 8px"}}>
                                  {
                                    paymentSources.online.map((data, index) => (
                                      <div key={index} onClick={()=>handleSelectPaymentSource(data)} className="global-input-field-arrow-dropdown-item d-flex">
                                        <p className="font-weight-600 fs-16 flex-item" style={{lineHeight:"16px"}}>{data}</p>
                                      </div>
                                    ))
                                  }
                                </div>
                              )
                            }
                            {
                              invoiceDetails.paymentMode == "wallet" && (
                                <div className="w-full" style={{padding:"0px 8px 8px 8px"}}>
                                  {
                                    paymentSources.wallet.map((data, index) => (
                                      <div key={index} onClick={()=>handleSelectPaymentSource(data)} className="global-input-field-arrow-dropdown-item d-flex">
                                        <p className="font-weight-600 fs-16 flex-item" style={{lineHeight:"16px"}}>{data}</p>
                                      </div>
                                    ))
                                  }
                                </div>
                              )
                            }
                          </div>
                        )
                      }
                    </div>
                </div>
              )  
            }

            {
              invoiceDetails.paymentMode == "cheque" && (
                <div className="w-full">
                  <div onClick={toggleInputFields('cheque-number')} className={`${currentElementId == "cheque-number" || invoiceDetails.chequeNumber ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} w-full m-b-12`} style={{ border: currentElementId == "cheque-number" || invoiceDetails.chequeNumber ? "1px solid var(--darkBlue)" : "" }}>
                    <div className="flex-item d-flex">
                      <p className="placeholder-txt flex-item" style={{ fontSize: currentElementId === "cheque-number" || invoiceDetails.chequeNumber ? "10px" : "14px", color: currentElementId == "cheque-number" || invoiceDetails.chequeNumber ? "var(--darkBlue)" : "", transition: "180ms" }}>Cheque Number</p>
                    </div>
                    <input id="cheque-number" value={invoiceDetails.chequeNumber} placeholder="Enter Cheque Number" onChange={handleChange("chequeNumber")} className={`${currentElementId == "cheque-number" || invoiceDetails.chequeNumber ? "active-input-field" : "inactive-input-field"}`} style={{ width:"100%", marginTop: isMobile ? "3px" : undefined }} type="text" />
                  </div>
                </div>
              ) 
            }

            {
              (invoiceDetails.paymentSource == "NEFT" || invoiceDetails.paymentSource == "RTGS" || invoiceDetails.paymentSource == "IMPS" ) && (
                <div className="w-full">
                  <div onClick={toggleInputFields('bank-name')} className={`${currentElementId == "bank-name" || invoiceDetails.bankName ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} w-full m-b-12`} style={{ border: currentElementId == "bank-name" || invoiceDetails.bankName ? "1px solid var(--darkBlue)" : "" }}>
                    <div className="flex-item d-flex">
                      <p className="placeholder-txt flex-item" style={{ fontSize: currentElementId === "bank-name" || invoiceDetails.bankName ? "10px" : "14px", color: currentElementId == "bank-name" || invoiceDetails.bankName ? "var(--darkBlue)" : "", transition: "180ms" }}>Bank Name</p>
                    </div>
                    <input id="bank-name" value={invoiceDetails.bankName} placeholder="Enter Bank Name" onChange={handleChange("bankName")} className={`${currentElementId == "bank-name" || invoiceDetails.bankName ? "active-input-field" : "inactive-input-field"}`} style={{ width:"100%", marginTop: isMobile ? "3px" : undefined }} type="text" />
                  </div>
                </div>
              )
            }

            {
              (invoiceDetails.paymentSource == "Credit Card" || invoiceDetails.paymentSource == "Debit Card") && (
                <div onClick={toggleInputFields("card-type")} className={`${currentElementId == "card-type" || invoiceDetails.cardType ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} m-b-12`} style={{ border: (currentElementId == "card-type" || invoiceDetails.cardType) ? "1px solid var(--darkBlue)" : "", height:"auto", minHeight:"54px", width:"100%" }}>
                  {
                    isMobile ? (
                      <div className='d-flex w-full space-between'>
                        <div className='flex-item'>
                          <div className="flex-item d-flex">
                            <svg className="flex-item m-r-4" width={(currentElementId == "card-type" || invoiceDetails.cardType) ? "14" : "24"} height={(currentElementId == "card-type" || invoiceDetails.cardType) ? "14" : "24"} style={{ transition: "180ms" }} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M13.5 12.423C12.936 12.423 12.4617 12.2307 12.077 11.846C11.6924 11.4613 11.5 10.987 11.5 10.423C11.5 9.859 11.6924 9.38467 12.077 9C12.4617 8.61533 12.936 8.423 13.5 8.423C14.064 8.423 14.5384 8.61533 14.923 9C15.3077 9.38467 15.5 9.859 15.5 10.423C15.5 10.987 15.3077 11.4613 14.923 11.846C14.5384 12.2307 14.064 12.423 13.5 12.423ZM7.30802 15.616C6.86335 15.616 6.48302 15.4577 6.16702 15.141C5.85035 14.8243 5.69202 14.444 5.69202 14V6.846C5.69202 6.402 5.85035 6.022 6.16702 5.706C6.48368 5.39 6.86368 5.23167 7.30702 5.231H19.692C20.1367 5.231 20.517 5.389 20.833 5.705C21.149 6.021 21.3074 6.40133 21.308 6.846V14C21.308 14.444 21.1497 14.824 20.833 15.14C20.517 15.4573 20.137 15.616 19.693 15.616H7.30802Z" fill={(currentElementId == "card-type" || invoiceDetails.cardType) ? "var(--darkBlue)" : "#6d6d6d"}/>
                            </svg>
                            <p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == "card-type" || invoiceDetails.cardType) ? "10px" : "16px", lineHeight: (currentElementId == "card-type" || invoiceDetails.cardType) ? "10px" : "16px", color: (currentElementId == "card-type" || invoiceDetails.cardType) ? "var(--darkBlue)" : "", transition: "180ms" }}>Card Type</p>
                          </div>
                          <input readOnly id="card-type" value={invoiceDetails.cardType || ""} type="text" className={`${(currentElementId == "card-type" || invoiceDetails.cardType) ? "active-input-field" : "inactive-input-field"}`} placeholder="Select Card Type" style={{ marginTop: (currentElementId == "card-type" || invoiceDetails.cardType) ? "6px" : "" }} />
                        </div>
                        <div className='input-field-arrow-dropdown' style={{ margin: "12px 8px 4px 0", transition: "180ms" }}>
                          <svg className="flex-item" style={{ transform: currentElementId == "card-type" ? "rotate(180deg)" : "", transition: "180ms" }} width="13" height="8" viewBox="0 0 13 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M1 1L6.5 6.5L12.5 1" stroke="var(--darkBlue)" strokeLinecap="round" />
                          </svg>
                        </div>
                      </div>
                    ) : (
                      <>
                        <div className="flex-item d-flex" style={{marginTop: (currentElementId == "card-type" || invoiceDetails.cardType) ? "4px" : ""}}>
                          <p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == "card-type" || invoiceDetails.cardType) ? "10px" : "16px", lineHeight: (currentElementId == "card-type" || invoiceDetails.cardType) ? "10px" : "16px", color: (currentElementId == "card-type" || invoiceDetails.cardType) ? "var(--darkBlue)" : "", transition: "180ms" }}>Card Type</p>
                        </div>
                        <div className='input-field-arrow-dropdown' style={{ margin: "18px 12px 4px 0", transition: "180ms" }}>
                          <svg className="flex-item" style={{ transform: currentElementId == "card-type" ? "rotate(180deg)" : "", transition: "180ms" }} width="13" height="8" viewBox="0 0 13 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M1 1L6.5 6.5L12.5 1" stroke="var(--darkBlue)" stroke-linecap="round" />
                          </svg>
                        </div>
                        <p id="card-type" className={`flex-item fs-16 m-t-24 ${(currentElementId == "card-type") ? "active-input-field color-grey-04" : invoiceDetails.cardType ? "active-input-field" : "inactive-input-field"}`}>{invoiceDetails.cardType ? invoiceDetails.cardType : "Select Card Type"}</p>
                      </>
                    )
                  }
                  {
                    currentElementId == "card-type" && (
                      <div className="global-input-field-arrow-dropdown global-input-field-arrow-dropdown-height-1 scaleFromTopToBottom" style={{background:"#f5f5f5", border: "1px solid #f5f5f5", marginTop : !isMobile && invoiceDetails.cardType ? "70px" : undefined}}>
                        <div className="w-full" style={{padding:"0px 8px 8px 8px"}}>
                          {
                            cardTypes.map((data, index) => (
                              <div key={index} onClick={()=>handleSelectCard(data)} className="global-input-field-arrow-dropdown-item d-flex">
                                <p className="font-weight-600 fs-16 flex-item" style={{lineHeight:"16px"}}>{data}</p>
                              </div>
                            ))
                          }
                        </div>
                      </div>
                    )
                  }
                </div>
              )
            }

            {
              (invoiceDetails.paymentSource == "Credit Card" || invoiceDetails.paymentSource == "Debit Card") && (
                <div onClick={toggleInputFields('approved-code')} className={`${currentElementId == "approved-code" || invoiceDetails.approvedCode ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} w-full m-b-12`} style={{ border: currentElementId == "approved-code" || invoiceDetails.approvedCode ? "1px solid var(--darkBlue)" : "" }}>
                  <div className="flex-item d-flex">
                    <p className="placeholder-txt flex-item" style={{ fontSize: currentElementId === "approved-code" || invoiceDetails.approvedCode ? "10px" : "14px", color: currentElementId == "approved-code" || invoiceDetails.approvedCode ? "var(--darkBlue)" : "", transition: "180ms" }}>Approved Code</p>
                  </div>
                  <input id="approved-code" value={invoiceDetails.approvedCode} placeholder="Enter Approved Code" onChange={handleChange("approvedCode")} className={`${currentElementId == "approved-code" || invoiceDetails.approvedCode ? "active-input-field" : "inactive-input-field"}`} style={{ width:"100%", marginTop: isMobile ? "3px" : undefined }} type="text" />
                </div>
              )
            }

            {
              (invoiceDetails.paymentSource == "UPI") && (
                <div onClick={toggleInputFields('upi-id')} className={`${currentElementId == "upi-id" || invoiceDetails.upiId ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} w-full m-b-12`} style={{ border: currentElementId == "upi-id" || invoiceDetails.upiId ? "1px solid var(--darkBlue)" : "" }}>
                  <div className="flex-item d-flex">
                    <p className="placeholder-txt flex-item" style={{ fontSize: currentElementId === "upi-id" || invoiceDetails.upiId ? "10px" : "14px", color: currentElementId == "upi-id" || invoiceDetails.upiId ? "var(--darkBlue)" : "", transition: "180ms" }}>Aadhaar No./Mobile No.</p>
                  </div>
                  <input id="upi-id" value={invoiceDetails.upiId} placeholder="Enter Aadhaar or Mobile No. or UPI ID" onChange={handleChange("upiId")} className={`${currentElementId == "upi-id" || invoiceDetails.upiId ? "active-input-field" : "inactive-input-field"}`} style={{ width:"100%", marginTop: isMobile ? "3px" : undefined }} type="text" />
                </div>
              )
            }

            {
              (invoiceDetails.paymentSource == "Paytm" || invoiceDetails.paymentSource == "PhonePe" || invoiceDetails.paymentSource == "Google Pay" || invoiceDetails.paymentSource == "Amazon Pay") && (
                <div onClick={toggleInputFields('payment-number')} className={`${currentElementId == "payment-number" || invoiceDetails.paymentNumber ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} w-full m-b-12`} style={{ border: currentElementId == "payment-number" || invoiceDetails.paymentNumber ? "1px solid var(--darkBlue)" : "" }}>
                  <div className="flex-item d-flex">
                    <p className="placeholder-txt flex-item" style={{ fontSize: currentElementId === "payment-number" || invoiceDetails.paymentNumber ? "10px" : "14px", color: currentElementId == "payment-number" || invoiceDetails.paymentNumber ? "var(--darkBlue)" : "", transition: "180ms" }}>Payment mobile number</p>
                  </div>
                  <input id="payment-number" value={invoiceDetails.paymentNumber} placeholder="Enter payment mobile number" onChange={handleChange("paymentNumber")} className={`${currentElementId == "payment-number" || invoiceDetails.paymentNumber ? "active-input-field" : "inactive-input-field"}`} style={{ width:"100%", marginTop: isMobile ? "3px" : undefined }} type="text" />
                </div>
              )
            }

            {
              (invoiceDetails.paymentSource == "NEFT" || invoiceDetails.paymentSource == "RTGS" || invoiceDetails.paymentSource == "IMPS" || invoiceDetails.paymentSource == "UPI" || invoiceDetails.paymentSource == "Juice" || invoiceDetails.paymentSource == "Paytm" || invoiceDetails.paymentSource == "PhonePe" || invoiceDetails.paymentSource == "Google Pay" || invoiceDetails.paymentSource == "Amazon Pay") && (
                <div onClick={toggleInputFields('transaction-id')} className={`${currentElementId == "transaction-id" || invoiceDetails.transactionID ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} w-full m-b-12`} style={{ border: currentElementId == "transaction-id" || invoiceDetails.transactionID ? "1px solid var(--darkBlue)" : "" }}>
                  <div className="flex-item d-flex">
                    <p className="placeholder-txt flex-item" style={{ fontSize: currentElementId === "transaction-id" || invoiceDetails.transactionID ? "10px" : "14px", color: currentElementId == "transaction-id" || invoiceDetails.transactionID ? "var(--darkBlue)" : "", transition: "180ms" }}>Transaction ID</p>
                  </div>
                  <input id="transaction-id" value={invoiceDetails.transactionID} placeholder="Enter Transaction ID" onChange={handleChange("transactionID")} className={`${currentElementId == "transaction-id" || invoiceDetails.transactionID ? "active-input-field" : "inactive-input-field"}`} style={{ width:"100%", marginTop: isMobile ? "3px" : undefined }} type="text" />
                </div>
              )
            }


            {
              invoiceDetails.paymentMode == "other" && (
                <div onClick={toggleInputFields('comment')} className={`${currentElementId == "comment" || invoiceDetails.comment ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} w-full m-b-12`} style={{ border: currentElementId == "comment" || invoiceDetails.comment ? "1px solid var(--darkBlue)" : "" }}>
                  <div className="flex-item d-flex">
                    <p className="placeholder-txt flex-item" style={{ fontSize: currentElementId === "comment" || invoiceDetails.comment ? "10px" : "14px", color: currentElementId == "comment" || invoiceDetails.comment ? "var(--darkBlue)" : "", transition: "180ms" }}>Comment *</p>
                  </div>
                  <input id="comment" value={invoiceDetails.comment} placeholder="Enter Comment" onChange={handleChange("comment")} className={`${currentElementId == "comment" || invoiceDetails.comment ? "active-input-field" : "inactive-input-field"}`} style={{ width:"100%", marginTop: isMobile ? "3px" : undefined }} type="text" />
                </div>
              )
            }
            </div>


            <div onClick={toggleInputFields('remark')}  className={`${currentElementId == "remark" || remark ? "member-global-input-field flex-item" : "member-global-input-field flex-item d-flex"} m-b-40 m-t-20`} style={{ border: currentElementId == "remark" || remark ? "1px solid var(--darkBlue)" : "", width:"100%" }}>
              <div className="flex-item d-flex">
                <p className="placeholder-txt flex-item" style={{ fontSize: currentElementId == "remark" || remark ? "10px" : "14px", color: currentElementId == "remark" || remark ? "var(--darkBlue)" : "", transition: "180ms" }}>Remark</p>
              </div>
              <input id="remark" onChange={handleChange("remark")} placeholder='Enter Your Remarks Here' value={remark} className={`${currentElementId == "remark" || remark ? "active-input-field" : "inactive-input-field"}`} type="text" />
            </div>

          </div>

            <div className="bottom-action-button w-full d-flex" style={{background:"#ffffff", height:"60px", position:"absolute", bottom:0, borderRadius:"0 0 20px 20px"}}>
              <div className='d-flex space-between flex-item p-l-12 p-r-12 w-full' style={{gap: isMobile ? "12px" : undefined}}>
                <div onClick={()=>props.toggleFitnessTestModal("freeze-membership")} className={`member-button-global btn-center d-flex member-button-global-inactive`} style={{ width: isMobile ? "calc(50% - 6px)" : "48%", height:"40px", borderRadius:"20px" }}>
                  <p className="flex-item">Cancel</p>
                </div>
                <div onClick={isButtonLock?null:FreezeMembership} className={`member-button-global ${isButtonLock ? "member-button-global-inactive" : "global-blue-button-controller-active"} btn-center d-flex`} style={{ width: isMobile ? "calc(50% - 6px)" : "48%", height:"40px", borderRadius:"20px" }}>
                  <p className="flex-item">Freeze</p>
                </div>
              </div>
            </div>

        </div>
      </div>
    </div>
  )
}

export default FreezeMembershipModal;